/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { Link as ReactLink } from 'react-router-dom';
import { jsx, css } from '@emotion/core';
import { isInternalLink } from 'utils/string';

const base = css`
  &:hover {
    text-decoration: none;
  }
`;

type LinkProps = {
  to: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  style?: any;
  button?: boolean;
  block?: boolean;
  noDecoration?: boolean;
  anotherTab?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

export const BaseLink: React.FC<
  LinkProps &
    React.DetailedHTMLProps<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      HTMLAnchorElement
    >
> = ({
  to,
  style,
  block,
  noDecoration,
  anotherTab,
  disabled,
  onClick,
  children,
}) => {
  const Element = isInternalLink(to) ? ReactLink : 'a';
  const elementStyle = css`
    ${base};
    display: ${block ? 'block' : 'inline-block'};
    text-decoration: ${noDecoration ? 'none' : 'underline'};
    pointer-events: ${disabled ? 'none' : 'auto'};
    ${style};
  `;

  const handleClick = React.useCallback(async () => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  const props = {
    to,
    href: to,
    target: anotherTab ? '_blank' : undefined,
    rel: anotherTab ? 'noopener noreferrer' : undefined,
    css: elementStyle,
  };

  return (
    <Element {...props} onClick={handleClick}>
      {children}
    </Element>
  );
};
